<div *ngIf="spinner()" class="spinner-modal">
  <div class="spinner loading">
    <mat-spinner></mat-spinner>
  </div>
</div>
